import { render } from "./OpportunityDetail.vue?vue&type=template&id=574594ce&scoped=true"
import script from "./OpportunityDetail.vue?vue&type=script&lang=js"
export * from "./OpportunityDetail.vue?vue&type=script&lang=js"

import "./OpportunityDetail.vue?vue&type=style&index=0&id=574594ce&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-574594ce"],['__file',"src/views/qywx/common/partner/opportunity/OpportunityDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "574594ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('574594ce', __exports__)) {
    api.reload('574594ce', __exports__)
  }
  
  module.hot.accept("./OpportunityDetail.vue?vue&type=template&id=574594ce&scoped=true", () => {
    api.rerender('574594ce', render)
  })

}


export default __exports__